<template>
  <form ref="form" action="#" method="post">
    <input type="hidden" name="_token" :value="csrfToken" />
    <div class="l-page l-page--message-edit">
      <main class="l-main">
        <!-- パンくずリスト -->
        <breadcrumb :breadcrumb-data="breadcrumbData" />
        <!-- /パンくずリスト -->

        <div class="l-main-head">
          <div class="c-title u-w420">
            <div v-if="!messageId" class="c-title__text c-title__text--blue u-fs34">配信メッセージの新規作成</div>
            <div v-else class="c-title__text c-title__text--blue u-fs34">配信メッセージの編集</div>
          </div>
          <div class="c-progress">
            <ul class="c-progress-list">
              <li class="c-progress-list__item is-current">メッセージの作成</li>
              <li class="c-progress-list__item">配信条件の設定</li>
              <li class="c-progress-list__item">配信内容の確認</li>
              <li class="c-progress-list__item">設定完了</li>
            </ul>
          </div>
        </div>
        <div class="l-main-content">
          <div class="p-message-edit p-message-edit--message-group">
            <div class="c-title c-title--left">
              <div class="c-title__text u-fs24">メッセージのグループ管理名を登録する</div>
              <div class="c-text u-fs--s">配信するメッセージをグループとして管理していきます</div>
            </div>
            <div class="p-message-edit-list p-message-edit-list--first">
              <div class="p-message-edit-list__item">
                <div class="c-input u-w50p">
                  <div class="c-input__title"><span class="c-input__text c-input__text--required">【必須】</span>プッシュ名を設定する</div>
                  <input
                    v-model="messageName"
                    class="c-input__item"
                    type="text"
                    name="push_name"
                    value=""
                    placeholder="プッシュ名を入力してください"
                    maxlength="300"
                  />
                  <div class="c-error c-error--balloon">
                    <div class="c-error__text"></div>
                  </div>
                </div>
              </div>
              <div class="p-message-edit-list__item">
                <div class="c-input u-w50p">
                  <div class="c-input__title"><span class="c-input__text c-input__text--required">【必須】</span></div>
                </div>
                <div class="c-radio u-w100p">
                  <ul class="c-radio-list">
                    <li class="c-radio-list__item u-w50p">
                      <label class="c-radio__label">
                        <input
                          v-model="groupType"
                          type="radio"
                          name="message_group"
                          value="1"
                        />
                        <div class="c-radio__item">
                          <div class="c-radio__box"></div>
                          <div class="c-radio__box-label">すでにあるグループを設定する</div>
                        </div>
                      </label>
                    </li>
                    <li class="c-radio-list__item u-w50p">
                      <label class="c-radio__label">
                        <input
                          v-model="groupType"
                          type="radio"
                          name="message_group"
                          value="2"
                        />
                        <div class="c-radio__item">
                          <div class="c-radio__box"></div>
                          <div class="c-radio__box-label">新しくグループを設定する</div>
                        </div>
                      </label>
                    </li>
                  </ul>
                  <div class="c-error">
                    <div class="c-error__text"></div>
                  </div>
                </div>
              </div>
              <div class="p-message-edit-list__item">
                <select-text
                  ref="groupSelect"
                  :classes="['u-w450']"
                  place-holder="グループ名を選択してください"
                  :elements="messageInfo.messageGroups"
                  input-name="group_name_select"
                  @select="onGroupSelect"
                />
                <div class="c-input u-w466">
                  <input
                    v-model="newGroupName"
                    class="c-input__item"
                    type="text"
                    name="message_group_name"
                    value=""
                    placeholder="新しいグループ名を入力してください"
                    maxlength="300"
                  />
                  <div class="c-error c-error--balloon c-error--group-name">
                    <div class="c-error__text"></div>
                  </div>
                </div>
                <div class="c-text c-text--desc">
                  ※グループとは、配信メッセージをグループでまとめることが出来ます。グループ毎に配信結果を確認するなど分析時ご利用頂けます。
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="l-main-content l-main-content--half l-main-content--left">
          <!-- 配信メッセージ設定 -->
          <message-form
            ref="messageForm"
            v-model="message"
            :custom-utm-parameters="customUtmParameters"
            @optimize-start="onStartOptimize"
            @optimize-end="onEndOptimize"
            @page-data-fetched="autofillPushName"
          />
          <message-action-form ref="messageActionForm" v-model="messageAction" :skip-regular="!messageInfo.useRegularDelivery" />
        </div>
        <div class="l-main-content l-main-content--half l-main-content--right">
          <div class="p-message-preview">
            <div class="c-title c-title--left u-text-white-1">
              <div class="c-title__text u-fs--l ">プレビュー</div>
              <div class="c-text u-fs10">実際の配信メッセージと表示が異なることがあります</div>
            </div>

            <ul class="c-tab-list">
              <li
                class="c-tab-list__item"
                :class="{'is-active': previewType == 'desktop' }"
                data-type="desktop"
                @click="chengePreviewType('desktop')"
              >PCでの配信例</li>
              <li
                class="c-tab-list__item"
                :class="{'is-active': previewType == 'mobile' }"
                data-type="mobile"
                @click="chengePreviewType('mobile')"
              >Androidでの配信例</li>
            </ul>

            <div v-show="previewType == 'desktop'" class="p-message-preview-list">
              <message-preview
                :title="message.messageTitle"
                :text="message.messageText"
                :url="message.clickUrl"
                :icon-url="previewIconUrl"
                :large-image-url="message.largeImageUrl"
                :has-button-a="message.hasButtonA"
                :has-button-b="message.hasButtonB"
                :action-button-text-a="message.actionButtonTextA"
                :action-button-url-a="message.actionButtonUrlA"
                :action-button-text-b="message.actionButtonTextB"
                :action-button-url-b="message.actionButtonUrlB"
              />
            </div>
            <div v-show="previewType == 'mobile'" class="p-message-preview-list">
              <message-preview-sp
                :title="message.messageTitle"
                :text="message.messageText"
                :url="message.clickUrl"
                :icon-url="previewIconUrl"
                :large-image-url="message.largeImageUrl"
                :badge-url="previewBadgeUrl"
                :has-button-a="message.hasButtonA"
                :has-button-b="message.hasButtonB"
                :action-button-text-a="message.actionButtonTextA"
                :action-button-url-a="message.actionButtonUrlA"
                :action-button-text-b="message.actionButtonTextB"
                :action-button-url-b="message.actionButtonUrlB"
              />
            </div>
          </div>
        </div>
      </main>
    </div>
    <div class="p-message-predict">
      <div class="p-message-predict__content">
        <div class="p-message-predict-suspend">
          <div class="p-message-predict-suspend__items">
            <button
              class="c-btn c-btn--block u-w146 u-fs24"
              type="button"
              name="destroy"
              value="destroy"
              @click="onQuitClick"
            >
              <p class="c-btn__text">作成をやめる</p>
            </button>
          </div>
          <div class="p-message-predict-suspend__items">
            <button
              class="c-btn c-btn--block u-w96 u-fs24"
              :class="{ 'is-loading': isLoadingSaveBtn || isLoadingOptimizeImage }"
              :disabled="isLoadingSaveBtn || isLoadingOptimizeImage"
              type="button"
              name="save"
              value="save"
              @click="onSaveClick"
            >
              <p class="c-btn__text">保存する</p>
            </button>
          </div>
        </div>
        <reach-count ref="reachCount" :failure-message="reachCountFailureMessage" failure-tone="info" />
        <div class="p-message-predict__btns">
          <button
            v-if="useCondition"
            class="c-btn c-btn--blue u-w320 u-h50 u-fs20"
            :class="{ 'is-loading': isLoadingNextBtn || isLoadingOptimizeImage }"
            :disabled="isLoadingNextBtn || isLoadingOptimizeImage"
            type="button"
            name="next"
            value="next"
            @click="onNextClick($event)"
          >
            <p class="c-btn__text">次へ（配信条件の設定）</p>
          </button>
          <button
            class="c-btn c-btn--blue u-w320 u-h50 u-fs20"
            :class="{ 'is-loading': isLoadingConfirmBtn || isLoadingOptimizeImage }"
            :disabled="isLoadingConfirmBtn || isLoadingOptimizeImage"
            type="button"
            name="confirm"
            value="confirm"
            @click="onConfirmClick()"
          >
            <p class="c-btn__text">{{ confirmButtonText }}</p>
          </button>
        </div>
      </div>
    </div>
    <!-- モーダル: 次へボタンクリック -->
    <control-modal
      ref="refControlModal"
      classes="c-modal--message-delete"
      title="確認メッセージ"
      :body="`すでに配信済のメッセージです。メッセージを編集しますか？`"
      cancel-button-label="キャンセル"
      enter-button-label="OK"
      :is-active=nextMessageButtonFlg
      :on-close-click="onCloseConrolModal"
      :on-cancel-click="onCloseConrolModal"
      :on-enter-click="onEnterConrolModalForNextButtton"
    />

    <!-- モーダル: 確認画面へボタンクリック -->
    <control-modal
      ref="refConfirmationButtonModal"
      classes="c-modal--message-delete"
      title="確認メッセージ"
      :body="`すでに配信済のメッセージです。メッセージを編集しますか？`"
      cancel-button-label="キャンセル"
      enter-button-label="OK"
      :is-active=confirmationButtonFlg
      :on-close-click="onCloseConrolModal"
      :on-cancel-click="onCloseConrolModal"
      :on-enter-click="onEnterConrolModalForConfirmButtton"
    />

    <!-- モーダル: 保存するボタンクリック -->
    <control-modal
      ref="refSavedButtonModal"
      classes="c-modal--message-delete"
      title="確認メッセージ"
      :body="`すでに配信済のメッセージです。メッセージを保存しますか？`"
      cancel-button-label="キャンセル"
      enter-button-label="OK"
      :is-active=savedMessageButtonFlg
      :on-close-click="onCloseConrolModal"
      :on-cancel-click="onCloseConrolModal"
      :on-enter-click="onEnterConrolModalForSavedButtton"
    />

    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </form>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import store from "../../funcs/store.js";
import ReachCount from '../molecules/ReachCount.vue';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');

export default {
  components: { ReachCount },
  props: {
    addConditionUrl: String,
    addConditionConfirmUrl: String,
    breadcrumbData: Array,
    csrfToken: String,
    messageInfo: Object,
    customUtmParameters: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      reachCountFailureMessage: '配信される予測数を取得できませんでした。\n表示できなくても配信は通常どおり行えますので、ご安心ください。',


      isLoadingConfirmBtn: false,
      isLoadingNextBtn: false,
      isLoadingSaveBtn: false,
      isLoadingOptimizeImage: false,
      message: {
        messageTitle: null,
        messageText: null,
        clickUrl: null,
        iconUrl: null,
        selectedIconFile: null,
        largeImageUrl: null,
        selectedLargeImageFile: null,
        hasButtonA: false,
        hasButtonB: false,
        actionButtonTextA: null,
        actionButtonUrlA: null,
        actionButtonTextB: null,
        actionButtonUrlB: null,
        adFlag: null,
        badgeUrl: null,
        selectedBadgeFile: null,
        customUtmParameter: null,
        customUtmParameterActionA: null,
        customUtmParameterActionB: null,
      },
      messageAction: {
        requireInteraction: '0',
        sendStartDate: null,
        sendStartTime: null,
        deliverType: '1',
        regularType: [],
        regularStartDate: null,
        regularEndDate: null,
        targetStartTime: null,
      },
      deliverStatus:null,
      messageId: null,
      messageName: null,
      groupId: null,
      groupType: null,
      newGroupName: null,
      currentButton: null,
      serviceType: null,
      errorMessage: '',
      isError: false,
      previewType: 'desktop',

      // フラグ系
      confirmationButtonFlg: false,
      nextMessageButtonFlg: false,
      savedMessageButtonFlg: false,
      useTargetReachCount: this.messageInfo.useTargetReachCount || store.state.user.isSystemAdminEdit,
    }
  },
  computed: {
    previewIconUrl: function () {
      return this.message.iconUrl || this.messageInfo.defaultIconUrl;
    },
    previewBadgeUrl: function () {
      return this.message.badgeUrl || this.messageInfo.defaultBadgeUrl;
    },
    useCondition: function() {
      return store.getResourceAccessRules()['DELIVERY_CONDITION'];
    },
    confirmButtonText: function() {
      return this.useCondition ? 'スキップして確認画面へ' : '確認画面へ';
    },
  },
  mounted: function() {
    // ページオープン時のローカルストレージにグループが存在している場合
    const key = 'default_group_' + this.messageInfo.serviceId + '_' + this.messageInfo.serviceType;
    const groupID = localStorage.getItem(key);
    if(groupID){
      this.groupType = 1;
      this.groupId = groupID;
      this.$refs.groupSelect.setValue(groupID);
    }

    import('../../funcs/pages/message-add').then(module => {
      module.MessageAdd();
    });
    import('../../funcs/components/select').then(module => {
      module.Select();
    });
    if(this.messageInfo.message){
      let message = this.messageInfo.message;

      this.serviceType = message.service_type;

      if(this.messageInfo.type == 'edit'){
        this.messageId = message.message_id;
      }
      this.messageName = message.message_name;
      this.message.messageTitle = message.message_title;
      this.message.messageText = message.message_text;
      this.message.clickUrl = message.click_url;
      this.messageAction.requireInteraction = message.require_interaction;
      if(message.action_button_text_a && message.action_button_url_a){
        this.message.hasButtonA = true;
        this.message.actionButtonTextA = message.action_button_text_a;
        this.message.actionButtonUrlA = message.action_button_url_a;
      } else {
        this.message.hasButtonA = false;
      }
      if(message.action_button_text_b && message.action_button_url_b){
        this.message.hasButtonB = true;
        this.message.actionButtonTextB = message.action_button_text_b;
        this.message.actionButtonUrlB = message.action_button_url_b;
      } else {
        this.message.hasButtonB = false;
      }

      this.messageAction.deliverType = message.message_deliver.deliver_type;
      this.deliverStatus = message.deliver_status;

      // 予約配信の場合
      if(this.messageAction.deliverType == 1){
        this.messageAction.sendStartDate = message.message_deliver.send_start_date;
        this.messageAction.sendStartTime = (
          message.message_deliver.send_start_date && dayjs(message.message_deliver.send_start_date).isValid()
        ) ? dayjs(message.message_deliver.send_start_date).format('HH:mm') : null;

        // 定期配信
      } else if(this.messageAction.deliverType == 3){
        // message_deliver.regular_type に曜日情報 0111110 1がON
        // target_start_time に 配信開始時間
        let regularType = message.message_deliver.regular_type;
        this.messageAction.regularType = [];
        for(let day = 0; day < 7; day++){
          let flag = regularType.substring(day,day+1);
          if(flag == '1'){
            this.messageAction.regularType.push('' + day);
          }
        }
        this.messageAction.regularStartDate = message.message_deliver.send_start_date;
        this.messageAction.regularEndDate = message.message_deliver.send_end_date;
        this.messageAction.targetStartTime = message.message_deliver.target_start_time;
      }

      if(message.message_group_message != null){
        this.groupType = 1;

        // group_idでマッチするが、実際に子コンポーネントにわたす値は「連番_groupe_id」をわたす
        let keyword;
        for(let key in this.messageInfo.messageGroups){
          keyword = key.split("_")[1];
          if(message.message_group_message.group_id == keyword) {
            this.groupId = message.message_group_message.group_id;
            this.$refs.groupSelect.setValue(key);
            break;
          }
        }
      } else {
        this.groupType = 2;
      }

      if(message.image_url){
        this.message.iconUrl = message.image_url;
      }
      if(message.large_image_url){
        this.message.largeImageUrl = message.large_image_url;
      }
      if(message.badge_url){
        this.message.badgeUrl = message.badge_url;
      }

      this.message.adFlag = (message.ad_flag == 1);
    } else {
      this.serviceType = this.messageInfo.serviceType;
    }
  },
  methods: {
    // -----------------------------------------------------------------------------------------------------
    // イベント系メソッド一覧: UI操作にフックしてコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: 確認画面へボタンのモーダルオープン
    onConfirmationMessage: function(_message) {
      this.confirmationButtonFlg = true;
    },
    // クリック: 次へボタンモーダルオープン
    onNextMessage: function(_message) {
      this.nextMessageButtonFlg = true;
    },
    // クリック: 保存ボタンモーダルオープン
    onSavedMessage: function(_message) {
      this.savedMessageButtonFlg = true;
    },
    // クリック: 確認メッセージのモーダルOKボタンクリック時
    onEnterConrolModalForConfirmButtton() {
      this.saveMessage(this.messageInfo.addConditionConfirmUrl + '?skip=1',true);
      this.onCloseConrolModal();
    },
    // クリック: 次へボタンのモーダルOKボタンクリック時
    onEnterConrolModalForNextButtton() {
      this.saveMessage(this.messageInfo.addConditionUrl,true);
      this.onCloseConrolModal();
    },
    // クリック: 保存ボタンのモーダルOKボタンクリック時
    onEnterConrolModalForSavedButtton() {
      this.saveMessage(this.messageInfo.listUrl,false);
      this.onCloseConrolModal();
    },
    // クリック: 確認メッセージのモーダルを閉じる処理
    onCloseConrolModal() {
      this.updateLocalStorage();

      this.confirmationButtonFlg = false;
      this.nextMessageButtonFlg = false;
      this.savedMessageButtonFlg = false;

      this.isLoadingConfirmBtn = false;
      this.isLoadingNextBtn = false;
      this.isLoadingSaveBtn = false;
    },

    // クリック: 配信条件設定画面へ
    onNextClick: function(event) {
      event.preventDefault();
      if(this.validate()){
        if (!this.checkPayloadSize()) {
          this.isError = true;
          this.errorMessage = 'プッシュ通知のサイズが大きすぎます。';
          return;
        }

        this.isLoadingNextBtn = true;

        // 配信ステータス：配信済
        const delivered = '30';
        if(this.deliverStatus === delivered){
          this.onNextMessage();
        } else {
          this.updateLocalStorage();
          this.saveMessage(this.messageInfo.addConditionUrl,true);
        }
      } else {
        this.isError = true;
        this.errorMessage = '入力を確認してください';
      }
    },

    // クリック: 確認画面へ
    onConfirmClick: function() {
      if (this.validate()) {
        if (!this.checkPayloadSize()) {
          this.isError = true;
          this.errorMessage = 'プッシュ通知のサイズが大きすぎます。';
          return;
        }
        this.isLoadingConfirmBtn = true;

        // 配信ステータス：配信済
        const delivered = '30';
        if(this.deliverStatus === delivered){
          this.onConfirmationMessage();
        } else {
          this.updateLocalStorage();
          this.saveMessage(this.messageInfo.addConditionConfirmUrl + '?skip=1',true);
        }
      } else {
        this.isError = true;
        this.errorMessage = '入力を確認してください';
      }
    },

    // クリック: 作成キャンセル
    onQuitClick: function() {
      location.href = this.messageInfo.listUrl;
    },

    chengePreviewType: function(type) {
      this.previewType = type;
    },

    // クリック: 作成内容の途中保存
    onSaveClick: function() {
      if (this.validate()) {
        if (!this.checkPayloadSize()) {
          this.isError = true;
          this.errorMessage = 'プッシュ通知のサイズが大きすぎます。';
          return;
        }
        this.isLoadingSaveBtn = true;

        // 配信ステータス：配信済
        const delivered = '30';
        if(this.deliverStatus === delivered){
          this.onSavedMessage();
        } else {
          this.updateLocalStorage();
          this.saveMessage(this.messageInfo.listUrl,false);
        }
      } else {
        this.isError = true;
        this.errorMessage = '入力を確認してください';
      }
    },
    onGroupSelect: function(selected) {
      this.groupId = selected;
    },

    updateLocalStorage: function() {
      if (this.groupType == 1 && this.groupId) {
        const key = 'default_group_' + this.messageInfo.serviceId + '_' + this.serviceType;
        window.localStorage.setItem(key, this.groupId);
      }
    },
    checkPayloadSize() {
      const payloadMaxSize = 4096; // 4KB
      const staticDataSize = 600; // アイコン画像/大型画像/ステータス画像のURLはバックエンドで決まるため、200バイトずつバッファを確保する。
      const maxSize = payloadMaxSize - staticDataSize;
      const values = [
        this.message.messageTitle,
        this.message.messageText,
        this.message.clickUrl,
        this.message.actionButtonTextA,
        this.message.actionButtonUrlA,
        this.message.actionButtonTextB,
        this.message.actionButtonUrlB
      ];
      let payloadSize = new Blob([values.map(value => value).join('')]).size;

      return payloadSize <= maxSize;
    },
    validate: function() {
      let isValid = true;
      let errors = {};
      if(!this.messageName){
        errors['push_name'] = 'プッシュ名を入力してください';
      }

      if(this.groupType == 1){
        if(!this.groupId){
          errors['group_name_select'] = 'グループ名を選択してください';
        }
      } else if(this.groupType == 2){
        if(!this.newGroupName){
          errors['message_group_name'] = 'グループ名を入力してください';
        }
      } else {
        errors['message_group'] = 'グループ設定を選択してください';
      }

      this.$refs.messageForm.validate(errors);
      this.$refs.messageActionForm.validate(errors);

      if(Object.keys(errors).length > 0){
        this.showErrors(errors);
        isValid = false;
      }

      return isValid;
    },
    appendForm(params,name,value){
      // null/undefinedの場合のみスキップ、空文字列や0は送信する
      if(value !== null && value !== undefined){
        params.append(name,value);
      }
    },
    appendUtmParameter(url, value) {
      let parameterValue = this.customUtmParameters[value];
      // parameterValueが存在しない、または文字列でない場合は元のURLを返す
      if (!parameterValue || typeof parameterValue !== 'string') {
        return url;
      }
      if (parameterValue.startsWith('?') || parameterValue.startsWith('&')) {
        parameterValue = parameterValue.substring(1);
      }
      url += (url.includes('?') ? '&' : '?') + parameterValue;
      return url;
    },
    saveMessage: function(completeUrl,hasArgument) {
      let sendStartDate = null;
      let sendEndDate = null;
      let regularType = '';

      if(this.messageAction.deliverType == 1){
        // 予約
        sendStartDate = moment(this.messageAction.sendStartDate).format('YYYY-MM-DD') + ' ' + this.messageAction.sendStartTime + ':00';
      } else if(this.messageAction.deliverType == 3){
        // 定期
        sendStartDate = moment(this.messageAction.regularStartDate).format('YYYY-MM-DD') + ' ' + this.messageAction.targetStartTime + ':00';
        if (this.messageAction.regularEndDate) {
          sendEndDate = moment(this.messageAction.regularEndDate).format('YYYY-MM-DD') + ' ' + this.messageAction.targetStartTime + ':00';
        }

        for(let day = 0; day < 7; day++){
          if(this.messageAction.regularType.includes(''+day)){
            regularType += '1';
          } else {
            regularType += '0';
          }
        }
      } else if(this.messageAction.deliverType == 4){
        // 即時
      }

      let clickUrl = this.message.clickUrl;
      if (this.message.customUtmParameter) {
        clickUrl = this.appendUtmParameter(clickUrl, this.message.customUtmParameter);
      }

      //*
      let params = new FormData();
      this.appendForm(params,'message_id',this.messageId);
      this.appendForm(params,'service_type',this.serviceType);
      this.appendForm(params,'message_name',this.messageName);
      this.appendForm(params,'message_title',this.message.messageTitle);
      this.appendForm(params,'message_text',this.message.messageText);
      this.appendForm(params,'click_url',clickUrl);
      this.appendForm(params,'image_url',this.message.iconUrl);
      this.appendForm(params,'large_image_url',this.message.largeImageUrl);
      this.appendForm(params,'badge_url',this.message.badgeUrl);
      this.appendForm(params,'require_interaction',this.messageAction.requireInteraction);
      if(this.message.hasButtonA){
        let actionButtonUrlA = this.message.actionButtonUrlA;
        if (this.message.customUtmParameterActionA) {
          actionButtonUrlA = this.appendUtmParameter(actionButtonUrlA, this.message.customUtmParameterActionA);
        }
        this.appendForm(params,'action_button_text_a',this.message.actionButtonTextA);
        this.appendForm(params,'action_button_url_a',actionButtonUrlA);
        if(this.message.hasButtonB){
          let actionButtonUrlB = this.message.actionButtonUrlB;
          if (this.message.customUtmParameterActionB) {
            actionButtonUrlB = this.appendUtmParameter(actionButtonUrlB, this.message.customUtmParameterActionB);
          }
          this.appendForm(params,'action_button_text_b',this.message.actionButtonTextB);
          this.appendForm(params,'action_button_url_b',actionButtonUrlB);
        }
      }
      if(this.groupType == 1){
        let convertedGroupId = this.groupId.slice(this.groupId.indexOf('_') + 1);
        this.appendForm(params,'group_id',convertedGroupId);
      } else if(this.groupType == 2){
        this.appendForm(params,'group_name',this.newGroupName);
      }
      this.appendForm(params,'deliver_type',this.messageAction.deliverType);
      this.appendForm(params,'send_start_date',sendStartDate);
      this.appendForm(params,'send_end_date',sendEndDate);
      this.appendForm(params,'regular_type',regularType);
      this.appendForm(params,'target_start_time',this.messageAction.targetStartTime);
      params.append('ad_flag', this.message.adFlag ? '1' : '0');
      params.append('icon_file',this.message.selectedIconFile);
      params.append('large_image_file',this.message.selectedLargeImageFile);
      params.append('badge_file',this.message.selectedBadgeFile);
      //*/

      axios.post('/api/message/save',params)
        .then(res => {
          if(this.handleResponse(res)){
            var url = new URL(completeUrl);
            if(hasArgument){
              url.searchParams.append('message_id',res.data.message_id);
            }
            location.href = url;
          } else {
            this.isError = true;
            this.errorMessage = (res && res.data && res.data.message)
              ? res.data.message
              : 'メッセージの保存に失敗しました';
          }

          setTimeout(() => {
            this.isLoadingConfirmBtn = false;
            this.isLoadingNextBtn = false;
            this.isLoadingSaveBtn = false;
          }, 300);
        })
        .catch(error => {
          this.handleHttpError(error);
          this.isError = true;
          this.errorMessage = 'メッセージの保存に失敗しました';
          setTimeout(() => {
            this.isLoadingNextBtn = false;
            this.isLoadingSaveBtn = false;
          }, 300);
        });
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
    // 遷移先 URL のページ情報でタイトルを自動入力したとき、RSSからの新規作成でプッシュ名が未入力ならタイトルを入れる
    autofillPushName(pageData) {
      if (this.messageId || this.messageName || !pageData.messageTitle) {
        return;
      }

      let params = new URL(document.location).searchParams;
      if (params.get('url') !== null) {
        this.messageName = pageData.messageTitle;
      }
    },
    // 画像最適化処理の開始
    onStartOptimize: function() {
      this.isLoadingOptimizeImage = true;
    },
    // 画像最適化処理の完了
    onEndOptimize: function() {
      this.isLoadingOptimizeImage = false;
    },
  }
}
</script>
